const $HD = {};
$HD.video = document.querySelector('.js-Video');
$HD.item = document.querySelector('.js-Video__item');

if($HD.video) {
  $HD.item.pause();

  setTimeout(function(){
    $HD.video.classList.add('is-show');
    $HD.item.play();
  }, 1000);
}

